// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = (ctx) => {
  return [
    // {
    //   prop: 'settlementCompanyNo',
    //   name: '公司名称',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_COMPANY_LIST_API,
    //   apiData: {
    //     adminFlag: ctx.userInfo.adminFlag,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   valueKey: 'companyCode',
    //   labelKey: 'companyName',
    //   changeMethod: 'changeCompanyHandler',
    //   method: 'post',
    // },
    // {
    //   prop: 'settlementDepartmentNo',
    //   name: '部门',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_DEPARTMENT_LIST_API,
    //   apiData: {
    //     belongCompanyCode: ctx.companyCode,
    //     tenantCode: ctx.userInfo.tenantCode,
    //   },
    //   clearable: true,
    //   filterable: true,
    //   disabled: !ctx.companyCode,
    //   valueKey: 'createDepartmentCode',
    //   labelKey: 'departmentName',
    //   method: 'post',
    // },
    {
      name: '客户',
      prop: 'customerNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      changeMethod: ctx.changeCustomerNoMethod,
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'contract',
      extraData: {
        contractCategory: 'sales',
      },
      isMultiple: true,
      changeMethod: ctx.changeContractMethod,
    },
    {
      name: '订单编号',
      prop: 'payableSettlementNo',
      type: 'input',
    },
    {
      name: '指令单编号',
      prop: 'payableSettlementNo',
      type: 'input',
    },
    {
      prop: 'product',
      name: '产品类型',
      type: 'select',
      options: ctx.dictListMap?.expenseType || [],
    },
    {
      prop: 'product',
      name: '服务类型',
      type: 'select',
      options: ctx.dictListMap?.expenseType || [],
    },
    {
      name: '指令下发时间从',
      prop: 'periodDateStart',
      type: 'startDaterangePicker',
    },
    {
      name: '指令下发时间至',
      prop: 'periodDateEnd',
      type: 'endDaterangePicker',
    },
  ];
};

// 默认表头
export const defaultTableColumn = [
  {
    type: 'radio',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'settlementDepartmentName',
    title: '部门',
    visible: true,
  },
  {
    field: 'payableSettlementNo',
    title: '平台公司',
    visible: true,
  },
  {
    field: 'settlementCompanyName',
    title: '客户名称',
    visible: true,
  },

  {
    field: 'settlementBusinessType',
    title: '订单编号',
    visible: true,
  },
  {
    field: 'supplierName',
    title: '产品类型',
    visible: true,
  },
  {
    field: 'settlementCenter',
    title: '服务类型',
    visible: true,
  },
  {
    field: 'settlementDate',
    title: '指令单号',
    visible: true,
  },
  {
    field: 'originalTotalAmount',
    title: '指令下发时间',
    visible: true,
  },
  {
    field: 'domesticTotalAmount',
    title: '业务员',
    visible: true,
  },
  {
    field: 'payableAccountPeriod',
    title: '编制人员',
    visible: true,
  },
  {
    field: 'projectInitiationNo',
    title: '订单状态',
    visible: true,
  },
];
export const tableList = [
  {
    id: 1,
    settlementDesc: '说明',
    originalPrice: 'A',
    settlementQuantity: 'b',
    unit: 1,
    originalAmount: 1,
    currencyCode: 'TEST',
    remark: 66666,
    projectInitiationNo: 88888,
    productName: '乐百氏',
  },
  {
    id: 2,
    payableSettlementNo: 2222,
    settlementDesc: 'eee',
    originalPrice: ' B',
    settlementQuantity: 'c',
    unit: 2,
    originalAmount: 2,
    currencyCode: 'TEST',
    remark: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 3,
    payableSettlementNo: 3333,
    settlementDesc: 'eee',
    originalPrice: ' B',
    settlementQuantity: 'c',
    unit: 3,
    originalAmount: 3,
    currencyCode: 'TEST',
    remark: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 4,
    payableSettlementNo: 4444,
    settlementDesc: 'eee',
    originalPrice: ' B',
    settlementQuantity: 'c',
    unit: 4,
    originalAmount: 4,
    currencyCode: 'TEST',
    remark: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 5,
    payableSettlementNo: 5555,
    settlementDesc: 'eee',
    originalPrice: ' B',
    settlementQuantity: 'c',
    unit: 5,
    originalAmount: 5,
    currencyCode: 'TEST',
    remark: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
];
// 默认显示的按钮
export const defaultMenuBtnList = [
  // {
  //   id: 1,
  //   label: '新建',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'add',
  //   },
  // },
  // {
  //   id: 2,
  //   label: '启用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'enable',
  //   },
  // },
  // {
  //   id: 3,
  //   label: '禁用',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'forbid',
  //   },
  // },
  {
    id: 4,
    label: '导出',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'export',
    },
  },
  // {
  //   id: 5,
  //   label: '批量导入',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  // {
  //   id: 6,
  //   label: '批准',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //     buttonUrl: 'approval',
  //   },
  // },
  // {
  //   id: 7,
  //   label: '驳回',
  //   type: '0',
  //   attributes: {
  //     buttonStyle: 'el-icon-remove-outline',
  //   },
  // },
  {
    id: 8,
    label: '创建结算单',
    type: '0',
    attributes: {
      // buttonStyle: 'el-icon-remove-outline',
      buttonUrl: 'create',
    },
  },
];
